import Enum from "./Enum";

export default Enum.create( {
	DEFAULT: "DEFAULT",
	WARNING: "WARNING",
	DANGER: "DANGER",
} );
